import { PrestationData } from "@/types"
import _ from "lodash"

export default {
   /**
   * Merge prestsToAdd into initialPrestationsArray,
   * keeping unique prestationId values.
   * 
   * The goal of `updateInitialPrestations` is to ensure that
   * any prestation returned from the availabilities endpoint
   * is included in the state and visible.
   * 
   */
    updateInitialPrestations: (
        {state, commit}: { 
            state: { initialPrestationsArray: PrestationData[] };
            commit: (type: string, payload?: any) => void 
        }, 
            prestsToAdd: PrestationData[]
        ) => {

        console.log("🚀 ~ prestations.js ~ updateInitialPrestations ~ prestsToAdd")

        // 1. Safe copies
        const initial = _.cloneDeep(state.initialPrestationsArray)
        const incoming = _.cloneDeep(prestsToAdd)

        // 2. Deduplicate and merge
        // - lodash has exactly what we need:
        //    _.unionBy keeps the *first* occurrence per key.
        //    Order: keep existing first, then add new ones.
        const merged = _.unionBy(initial, incoming, 'prestationId');

        commit('updateInitialPrestationsInState', merged);
    },
}